import { DateTime } from 'luxon';

/**
 * Calculates the max windowed sum of Activities per day
 * within a specified Project duration.
 *
 * @param startDate The start date of the project
 * @param duration The duration of the project in days
 * @param activitiesPerDay An object containing activities per day. (eg. { '2024-01-01': [], '2024-01-02': [] ... })
 * @param window The number of days to calculate sum. (e.g. 3)
 * @returns The maximum number of activities within the window.
 */
export function calculateMaxWindowedActivitiesSumForProject(
  startDateStr: string,
  duration: number,
  activitiesPerDay: Record<string, unknown[]>,
  window: number,
): number {
  let maxValue = -Infinity;
  let currentRunningSum = 0;
  const startDate = DateTime.fromISO(startDateStr);

  const daysArray = new Array(duration)
    .fill(0)
    .map((_, i) => startDate.plus({ days: i }));

  for (let i = 0; i < daysArray.length; i++) {
    const day = daysArray[i];
    const dayString = day.toISODate()!;

    // add the number of activities on this day to the running sum
    currentRunningSum += activitiesPerDay[dayString]?.length || 0;

    if (i >= window - 1) {
      maxValue = Math.max(maxValue, currentRunningSum);
      // remove the leftmost day of (the window) from the running sum
      const dayString = day.minus({ day: window - 1 }).toISODate()!;
      currentRunningSum -= activitiesPerDay[dayString]?.length || 0;
    }
  }

  return maxValue;
}
